// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

// import 'firebase/auth'

// TODO: Add SDKs for Firebase products that you want to use
import "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase тохиргоо
const firebaseConfig = {
  apiKey: "AIzaSyCSm7-QlmNbjy2sgDNeVMKJQwFJpMdr6lM",
  authDomain: "mymoney-29291.firebaseapp.com",
  databaseURL:
    "https://mymoney-29291-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mymoney-29291",
  storageBucket: "mymoney-29291.appspot.com",
  messagingSenderId: "293244169386",
  appId: "1:293244169386:web:01595bc5e2ad30e6e934d3",
};

// Firebase app үүсгэх
const app = initializeApp(firebaseConfig);

// Үйлчилгээнүүдийг экспортлох
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export const storage = getStorage(app);
// Functions-г бүс тодорхойлон (us-central1) ашиглах
export const functions = getFunctions(app, "us-central1");

// Аутентификацийн persistence-ийг LOCAL болгож тогтмол нэвтэрсэн төлөв хадгална
// Энэ нь хэрэглэгчийг 7+ хоногийн турш session-ээ хадгалах боломжтой болгоно
setPersistence(auth, browserLocalPersistence).catch(() => {
  // persistence алдаа гарвал чимээгүй алгасана
});
